<template>
    <div class="main-nav__wrapper" @mouseleave="closeMenu">
        <nav class="main-nav__bar">
            <ul class="main-nav__list">
                <li class="main-nav__item" v-for="cat in catData" :key="cat.id" @mouseenter="setActiveCat(cat.id)">
                    <a :href="buildUrl(cat)" class="main-nav__link" :class="{'main-nav__link--active': cat.id === activeCatId }">
                        <span>{{ cat.details[0].name }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6">
                            <path fill="#018FB8" fill-rule="evenodd" d="M117.788385,8.20160227 C117.637847,8.06719861 117.464152,8 117.267295,8 C117.070438,8 116.896743,8.06719861 116.746204,8.20160227 L112.820655,12.0152441 L108.895106,8.20160227 C108.744568,8.06719861 108.570873,8 108.374015,8 C108.177158,8 108.003463,8.06719861 107.852925,8.20160227 C107.702387,8.34720319 107.627119,8.51520293 107.627119,8.70560579 C107.627119,8.8960108 107.702387,9.06401054 107.852925,9.20961361 L112.299564,13.5104609 C112.380624,13.5888622 112.470367,13.6448623 112.568795,13.6784628 C112.667224,13.7120633 112.751176,13.7288634 112.820655,13.7288634 C112.890134,13.7288634 112.974086,13.7120633 113.072515,13.6784628 C113.170944,13.6448623 113.260686,13.5888622 113.341746,13.5104609 L117.788385,9.20961361 C117.938924,9.06401054 118.01419,8.8960108 118.01419,8.70560579 C118.01419,8.51520293 117.938924,8.34720319 117.788385,8.20160227 Z" transform="translate(-107 -8)"/>
                        </svg>
                    </a>
                </li>
            </ul>
        </nav>
        <div class="megamenu" v-if="isOpen && activeCat">
            <div class="megamenu__container" @mouseleave="closeMenu">
                <div class="row">
                    <div class="col-lg-9">
                        <p class="megamenu__title">
                            <span class="megamenu__title-main">{{ activeCat.details[0].name }}</span>
                            <template v-if="activeCat.details[0].shortDescription">
                                <span class="megamenu__title-separator" >-</span>
                                <span class="megamenu__title-sub">{{ activeCat.details[0].shortDescription }}</span>
                            </template>
                        </p>
                        <div class="megamenu__row-container">
                            <div class="row" v-if="typeof activeCat.children != 'undefined' ">
                                <div v-for="l2Child in activeCat.children" class="megamenu__l2-block" @mouseenter="setHoveredChildId(l2Child.id)">
                                    <a :href="buildUrl(activeCat, l2Child)" class="megamenu__l2-hl">{{ l2Child.details[0].name }}</a>
                                    <p class="megamenu__l2-subtitle" v-if="l2Child.details[0].shortDescription">{{ l2Child.details[0].shortDescription }}</p>
                                    <ul class="megamenu__child-list" v-if="typeof l2Child.children != 'undefined'">
                                        <li v-for="l3Child in l2Child.children">
                                            <a :href="buildUrl(activeCat, l2Child, l3Child)" class="megamenu__l3-link">
                                                    {{ l3Child.details[0].name }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 megamenu__img-col">
                        <div class="megamenu__image-container">
                            <transition>
                                <img class="megamenu__image" :key="hoveredChildId" :src="hoveredImageURL" :alt="hoveredCatName"/>
                            </transition>
                            <h4 class="skew-link" :key="hoveredCatName">
                                {{ hoveredCatName }}
                            </h4>
                                <!--<transition mode="out-in">
                                    <h4 class="skew-link" :key="hoveredChildId">
                                        {{ hoveredCatName }}
                                    </h4>
                                </transition>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MegaMenu",
        props: {
            catData: Array,
            placeHolderImg: {
                type: String,
                default: ""
            }
        },
        data(){
            return {
                isOpen: false,
                activeCatId:null,
                hoveredChildId: null,
                isLG: false
            }
        },
        computed:{
            activeCat(){
                return this.catData.find(cat => cat.id === this.activeCatId)
            },
            hoveredChild(){
                if (this.hoveredChildId && typeof this.activeCat.children != "undefined"){
                    return this.activeCat.children.find(child => child.id === this.hoveredChildId)
                }
            },
            hoveredCatName(){
                return this.hoveredChild && this.hoveredChild.details && this.hoveredChild.details[0].name || this.activeCat.details[0].name;
            },
            hoveredImageURL(){
                if(this.hoveredChild && this.hoveredChild.details && this.hoveredChild.details[0].image2Path){
                    return window.location.origin + "/documents/"+ this.hoveredChild.details[0].image2Path;
                }

                // return main cat img if exists:
                if (this.activeCat.details[0].image2Path){
                    return window.location.origin + "/documents/"+ this.activeCat.details[0].image2Path;
                }

                return this.placeHolderImg;
            },

        },
        methods:{
            getSubtitleFromMetaTile(cat){
                const mt = cat.details[0].metaTitle;

            },
            setActiveCat(catId){
                this.isOpen = true;
                this.activeCatId = catId;
            },
            buildUrl(l1, l2, l3){
                let urlString = "/" + l1.details[0].nameUrl;

                if (l2){
                    urlString += "/" + l2.details[0].nameUrl;
                }
                if (l2 && l3){
                    urlString += "/" + l3.details[0].nameUrl;
                }

                return urlString;
            },
            closeMenu(){
                this.isOpen = false;
                this.activeCatId = null;
            },
            setHoveredChildId(id){
                this.hoveredChildId = id;
            }
        },
    };
</script>


